import UserController from "@/controllers/UserController";
import AdminController from "@/controllers/AdminController";
import ContactsController from "@/controllers/ContactsController";
import debounce from "debounce-promise";
import FilesController from "@/controllers/FilesController";

export default {
  namespaced: true,
  state: {
    checkFilledContacts: false,
    contact: [],
    pages: [],
    blockInfo: [],
    blockInfoOrganization: {},
    allowBlock: {
      "messageStage1": [],
      "messageStage2": [],
      "messageStage3": []
    },
    files: [],
    filesLoading: false,
    adminInfo: null
  },
  mutations: {
    ['ADD_STATUS_CHECK_FILLED_CONTACTS'](state, payload) {
      state.checkFilledContacts = payload;
    },
    ['ADD_CONTACTS'](state, payload) {
      state.contact = payload;
    },
    ['PUSH_CONTACTS'](state, payload) {
      state.contact.push(payload);
    },
    ['BLOCK_INFO'](state, payload) {
      state.blockInfo = payload;
    },
    ['BLOCK_INFO_ORGANIZATION'](state, payload) {
      state.blockInfoOrganization = payload;
    },
    ['ADMIN_INFO'](state, payload) {
      state.adminInfo = payload;
    },
    ['ALLOW_BLOCK_SAVE'](state, payload) {
      state.allowBlock = payload
    },
    ['ALLOW_BLOCK_CLEAR'](state) {
      Object.keys(state.allowBlock).forEach(key => state.allowBlock[key] = [])
    },
    ['ADMIN_INFO_CHANGE_STAGE'](state, payload) {
      if (state.adminInfo.stage)
        state.adminInfo.stage = payload;
    },
    ['SET_FILES'](state, payload) {
      state.files = payload;
    },
    ['UPDATE_FILE_LIST'](state, payload) {
      const index = state.files.findIndex(el => el.fileType === payload.fileType);
      if (index === -1)
        state.files.push(payload);
      else
        state.files.splice(index, 1, payload);
    },
    ['FILES_STATUS'](state, payload) {
      state.filesLoading = payload;
    },
    ['PUSH_BLOCK_INFO'](state, data) {
      const checkForStageBlockInfoIndex = state.blockInfo.findIndex(el => el.stageId === data.stageId)
      if (checkForStageBlockInfoIndex !== -1)
        state.blockInfo.splice(checkForStageBlockInfoIndex, 1, data)
      else
        state.blockInfo.push(data);
    },
  },
  actions: {
    fetchCheckFilled({commit}, payload) {
      const {contacts} = payload;
      if (Array.isArray(contacts) && contacts && contacts.length >= 2 && (contacts[0]?.fio?.length > 0 || contacts[0]?.firstName?.length > 0)) {
        commit('ADD_STATUS_CHECK_FILLED_CONTACTS', true);
        commit('ADD_CONTACTS', contacts);
      } else if (contacts && contacts?.position && contacts?.fio?.length > 0 && contacts.email.length > 0 && contacts.position.length > 0) {
        commit('ADD_STATUS_CHECK_FILLED_CONTACTS', true);
        commit('ADD_CONTACTS', contacts);
      } else {
        commit('ADD_CONTACTS', contacts);
      }
    },
    async loadingBlockInfo({commit, rootGetters}) { /// ----
      console.log('loadingBlockInfo')
      return debounce(UserController.getBlockInfo().then(data => {
        if (rootGetters["keycloak/currentRole"] === 'ORGANIZATION_ROLE')
          commit('BLOCK_INFO_ORGANIZATION', data)
        else
          commit('BLOCK_INFO', data);
      }), 100, {leading: true});
    },
    updateBlockOrganizationInfo({commit}, payload) {
      // console.log('222')
      // console.log(payload)
      commit('BLOCK_INFO_ORGANIZATION', payload)
    },
    async getBlockAllows({commit, state}, stage) {
      try {
        await debounce(UserController.getBlockAllowInfo().then(data => {
          commit('ALLOW_BLOCK_SAVE', data);
        }), 100, {leading: true});
      } catch (e) {
        console.error(e)
      }
      return state.allowBlock['messageStage' + stage];
    },
    clearBlockInfo({commit}) {
      commit('BLOCK_INFO', []);
      commit('BLOCK_INFO_ORGANIZATION', {});
    },
    async getAdminInfoBlock({commit}) {
      // console.log(`начало`)
      await AdminController.getAdminInfo().then(data => {
        // console.log(data.stage);
        commit('ADMIN_INFO', data);
      });
      // console.log(`конец`)
    },
    updateAdminInfoBlock({commit}, stageId) {
      commit('ADMIN_INFO_CHANGE_STAGE', stageId)
    },
    loadingFiles({commit, rootGetters}) {
      if (rootGetters['keycloak/isAdminGroup'] && !rootGetters['keycloak/getFakeUser'])
        return;
      commit('FILES_STATUS', true);
      FilesController.getFileList().then(data => {
        commit('SET_FILES', data);
      }).finally(() => commit('FILES_STATUS', false));
    },
    reloadFiles({commit}) {
      // console.log(`reloadFiles`);
      FilesController.getFileList().then(data => {
        commit('SET_FILES', data)
      });
    },
    updateFiles({commit}, payload) {
      commit('FILES_STATUS', true);
      commit('UPDATE_FILE_LIST', payload);
      commit('FILES_STATUS', false)
    },
    changeBlockInfo({commit}, payload) {
      commit('PUSH_BLOCK_INFO', payload);
    },
    async getContact({dispatch, state, rootGetters}, role) {
      // console.log(`выполняем getContact`);
      try {
        let isOrg;
        if (!role)
          isOrg = rootGetters['keycloak/isOrganization'];
        else
          isOrg = role ? role === 'ORGANIZATION_ROLE' : rootGetters["keycloak/currentRole"] === 'ORGANIZATION_ROLE'
        // console.log(`выполняем await ContactsController.getOrganizationContact`);

        let type;
        let ID;
        if (rootGetters["keycloak/currentRole"] === 'FOUNDER_ROLE') {
          type = 'founder'
          ID = rootGetters["keycloak/userId"]
        } else if (rootGetters["keycloak/currentRole"] === "REGION_ROLE") {
          type = 'region'
          ID = rootGetters["keycloak/userId"]
        }

        await debounce(
          isOrg ?
            await ContactsController.getOrganizationContact().then(data => {
              if (data[0] && data[1])
                dispatch('fetchCheckFilled', {contacts: data});
            }) :
            await ContactsController.getContactController(type, ID).then(data => {
              if (data[0] && data[1])
                dispatch('fetchCheckFilled', {contacts: data});
            }), 400, {leading: true})
        // console.log(state.checkFilledContacts);
        return state.checkFilledContacts
      } catch (e) {
        console.error('111', e.message)
        throw new Error(e)
      }
    },
    addNewContact({commit}, payload) {
      commit('PUSH_CONTACTS', payload)
    }
  },
  getters: {
    get_check_filled_status(state) {
      return state.checkFilledContacts;
    },
    get_contact_data(state) {
      return state.contact;
    },
    currentStage(state) {
      return Number.parseInt(state.adminInfo?.stage) ?? 1;
    },
    getFilesList(state) {
      return state.files;
    },
    getFilesListStatus(state) {
      return state.filesLoading;
    },
    getBlockInfo(state) {
      return state.blockInfo;
    },
    getBlockInfoOrganization(state) {
      return state.blockInfoOrganization;
    },
    organizationBlocked(state) {
      return !!(state.blockInfoOrganization?.block || state.blockInfoOrganization?.konvert)
    },
    organizationSendKonvert(state) {
      return state.blockInfoOrganization?.konvert ?? false
    },
    getBlockStageOne(state, getters) {
      return state.blockInfo?.find(el => el.stageId === 1)?.block || getters['currentStage'] !== 1;
    },
    getBlockStageTwo(state, getters) {
      return state.blockInfo?.find(el => el.stageId === 2)?.block || getters['currentStage'] !== 2;
    },
    getBlockStageThree(state, getters) {
      return state.blockInfo?.find(el => el.stageId === 3)?.block || getters['currentStage'] !== 3;
    },
  }
}